import {AbstractRepository} from './AbstractRepository'
import 'core-js/es6/array';

export class ContentRepository extends AbstractRepository {
    content;

    constructor() {
        super();
        this.content = this.table('content');
    }

    findAll() {
        return new Promise(resolve => {
            this.transaction('rw', this.content, () => {
                this.content = this.content.toArray();
                resolve(this.content);
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    search(tags, types, searchWords) {
        return new Promise(resolve => {
            this.transaction('rw', this.content, () => {

                let selectedTags = [];

                tags.forEach(function(tag) {
                    selectedTags.push(tag.id);
                    if (tag.parent && tag.parent.id) {
                        selectedTags.push(tag.parent.id);
                    }
                    if (tag.parentParent && tag.parentParent.id) {
                        selectedTags.push(tag.parentParent.id);
                    }
                });
                let results;

                if(selectedTags && selectedTags.length === 1) {
                    results = this.content.where('tags').anyOf(selectedTags[0]);
                } else if(selectedTags && selectedTags.length > 1) {
                    results = this.content.where('tags').anyOf(selectedTags[0])
                    // .and(function(singleContent){
                    //     return singleContent.title === searchWords;
                    // })
                    .distinct();
                }
                else {
                    results = this.content.orderBy('title');
                }

                let resultsArrayPromise = results.toArray();
                resultsArrayPromise.then(function (filterResults) {
                    let resultsArray = filterResults.filter(function(result) {
                        let title = result.title.toLowerCase();
                        return title.indexOf(searchWords.toLowerCase()) !== -1
                    });

                    if (types.length > 0) {
                        resultsArray = resultsArray.filter(function(result) {
                            let isInArray = false;
                            types.forEach(function(type){
                               if(type.id == result.type) {
                                   isInArray = true;
                               }
                            });
                            return isInArray;
                        });
                    }


                    resolve(resultsArray);
                });
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    add(params) {
        return new Promise(resolve => {
            let content = params;
            this.transaction('rw', this.content, async () => {
                if(params.image1) {
                    content.image1 = params.image1
                }
                if(params.image1 === -1) {
                    content.image1 = '';
                }
                if(params.image2) {
                    content.image2 = params.image2
                }
                if(params.image2 === -1) {
                    content.image2 = '';
                }
                if(params.image3) {
                    content.image3 = params.image3
                }
                if(params.image3 === -1) {
                    content.image3 = '';
                }
                if(params.image4) {
                    content.image4 = params.image4
                }
                if(params.image4 === -1) {
                    content.image4 = '';
                }
                if(params.image5) {
                    content.image5 = params.image5
                }
                if(params.image5 === -1) {
                    content.image5 = '';
                }
                console.log('Save');
                console.log(content);
                let id = await this.content.add(content);
                    resolve({
                        id: id,
                        title: params.title,
                    });

            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    findById(id) {
        return new Promise(resolve => {
            this.transaction('rw', this.content, () => {
                this.content = this.content.where("id").equals(parseInt(id)).toArray();
                resolve(this.content);
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    update(editContent) {
        return new Promise(resolve => {
            this.transaction('rw', this.content, async () => {

                let content =  {
                    title: editContent.title,
                    type: editContent.type,
                    description: editContent.description,
                    tags: editContent.tags,
                    additionalData: editContent.additionalData,
                    codeType: editContent.codeType,
                };

                if(editContent.image1) {
                    content.image1 = editContent.image1
                }
                if(editContent.image1 === -1) {
                    content.image1 = '';
                }
                if(editContent.image2) {
                    content.image2 = editContent.image2
                }
                if(editContent.image2 === -1) {
                    content.image2 = '';
                }
                if(editContent.image3) {
                    content.image3 = editContent.image3
                }
                if(editContent.image3 === -1) {
                    content.image3 = '';
                }
                if(editContent.image4) {
                    content.image4 = editContent.image4
                }
                if(editContent.image4 === -1) {
                    content.image4 = '';
                }
                if(editContent.image5) {
                    content.image5 = editContent.image5
                }
                if(editContent.image5 === -1) {
                    content.image5 = '';
                }
                console.log('Update');
                console.log(content);

                resolve(this.content.update(editContent.id, content));
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    remove(id) {
        this.transaction('rw', this.content, async() => {
            await this.content.where("id").equals(id).delete();
        }).catch(e => {
            alert(e.stack || e);
        });
    }
}
